import { navigateTo } from '../http/redirect';
import PropertyFilterPopup from '../property/filter-popup';
import LocationSearchForm from '../property/location-search-form';
import Slider from '../slider/generic-slider';
import initStickyElementTrackers from '../sticky-tracker';
import initLazyLoadedStyles from '../lazyloading/styles';
import initRatingGroups from '../ratinggroup';
import initTooltips from '../tooltip';
import initListExpanders from '../list-expander';
import initInputEnablers from '../forms/input-enabler';
import initTags from '../tags';
import initScrollToTop from '../scrolltotop';

class LocationSearchPage {
    constructor() {
        this._initialiseComponents();
    }

    _initialiseComponents() {
        initLazyLoadedStyles();

        initStickyElementTrackers();

        initRatingGroups();

        initListExpanders();

        initInputEnablers();

        initTooltips();

        initTags();

        initScrollToTop();

        const baseForm = document.querySelector<HTMLFormElement>( '#location-search-form' );

        if ( baseForm ) {
            new LocationSearchForm( baseForm );
        }

        const filterPopup = document.querySelector<HTMLElement>( '#search-filter-popup' );

        if ( filterPopup && baseForm ) {
            new PropertyFilterPopup( filterPopup, baseForm );
        }

        const inlineOrderBy: HTMLSelectElement | null = document.querySelector( '#location-search-orderby' );
        if ( inlineOrderBy ) {
            inlineOrderBy.addEventListener( 'change', () => {
                const url = new URL( window.location.href );

                if ( inlineOrderBy.value === 'Properties' ) {
                    url.searchParams.delete( 'order' );
                } else {
                    url.searchParams.set( 'order', inlineOrderBy.value );
                }

                navigateTo( url.toString() );
            } );
        }

        const introExpander = document.querySelector( '#location-search-intro-readmore' ) as HTMLButtonElement;
        const introText = document.querySelector( '.locationsearchintro__introtext' ) as HTMLDivElement;
        const introTextContext = document.querySelector( '.locationsearchintro__introtext > div' ) as HTMLDivElement;

        if ( introExpander && introText && introTextContext ) {
            introExpander.addEventListener( 'click', ( event: Event ): void => {
                introExpander.classList.toggle( 'open' );
                const openTxt = introExpander.querySelector( '.open-text' ) as HTMLButtonElement;
                const closeTxt = introExpander.querySelector( '.closed-text' ) as HTMLButtonElement;

                if ( introText.classList.contains( 'locationsearchintro__introtext--hidden' ) ) {
                    introTextContext.classList.remove( 'd-none' );
                    closeTxt.classList.remove( 'd-none' );
                    openTxt.classList.add( 'd-none' );
                } else {
                    introTextContext.classList.add( 'd-none' );
                    closeTxt.classList.add( 'd-none' );
                    openTxt.classList.remove( 'd-none' );
                }

                introText.classList.toggle( 'locationsearchintro__introtext--hidden' );
            } );
        }

        document.querySelectorAll<HTMLElement>( '.glide' ).forEach( ( el: HTMLElement ) => new Slider( el ) );
    }
}

if ( !window.locationSearchPage ) {
    window.locationSearchPage = new LocationSearchPage();
}
